import { render, staticRenderFns } from "./edu.vue?vue&type=template&id=66ebbcd8&scoped=true"
import script from "./edu.vue?vue&type=script&lang=js"
export * from "./edu.vue?vue&type=script&lang=js"
import style0 from "./edu.vue?vue&type=style&index=0&id=66ebbcd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ebbcd8",
  null
  
)

export default component.exports